import { Type } from '@angular/core';
import { PageValidationType } from '../../models/projects/validation.models';
import { SidebarPermissions } from '../../models/permissions/permission.models';
import { SupportContextKey } from '../../models/support/support.models';
import { WeatherLogPage } from '../../pages/weather-readings/weather-log/weather-log';
import { DailyLegLoadsLogPage } from '../../pages/daily-leg-loads/daily-leg-loads-log/daily-leg-loads-log';
import { SafetyEditPage } from '../../pages/DPR Pages/safety/safety-edit/safety-edit';
import { ConsumableEditPage } from '../../pages/DPR Pages/consumables/consumable-edit/consumable-edit';
import { VesselCrewEditPage } from '../../pages/DPR Pages/vessel-crew/vessel-crew-edit/vessel-crew-edit';

export interface MenuSection {
  pageType: PageValidationType;
  title: string;
  validationLabel: string;
  readonly component: Type<any>;
  permission: keyof SidebarPermissions;
  requiresJacking: boolean;
  requiresDaySetup: boolean;
  supportContextKey: SupportContextKey;
}

// Use the original menu page classes, avoiding Ionic's named-page lazy loading.
// Resolve them on access because these pages also import shared validation components.
export const menuSections: MenuSection[] = [
  { pageType: PageValidationType.WeatherReading, title: 'Weather Log', validationLabel: 'Weather Readings',
    get component() { return WeatherLogPage; }, permission: 'canClickWeather', requiresJacking: true,
    requiresDaySetup: false, supportContextKey: SupportContextKey.WeatherLog },
  { pageType: PageValidationType.DailyLegLoad, title: 'Leg Loads', validationLabel: 'Daily Leg Loads',
    get component() { return DailyLegLoadsLogPage; }, permission: 'canClickDailyLegLoads', requiresJacking: true,
    requiresDaySetup: false, supportContextKey: SupportContextKey.LegLoads },
  { pageType: PageValidationType.Safety, title: 'HSEQ', validationLabel: 'HSEQ',
    get component() { return SafetyEditPage; }, permission: 'canClickSafety', requiresJacking: false,
    requiresDaySetup: true, supportContextKey: SupportContextKey.DprSections },
  { pageType: PageValidationType.Consumables, title: 'Consumables', validationLabel: 'Consumables',
    get component() { return ConsumableEditPage; }, permission: 'canClickConsumables', requiresJacking: true,
    requiresDaySetup: true, supportContextKey: SupportContextKey.DprSections },
  { pageType: PageValidationType.VesselCrew, title: 'POB', validationLabel: 'POB',
    get component() { return VesselCrewEditPage; }, permission: 'canClickVesselCrew', requiresJacking: false,
    requiresDaySetup: true, supportContextKey: SupportContextKey.DprSections }
];

export function menuSectionFor(pageType: PageValidationType): MenuSection | undefined {
  return menuSections.find(section => section.pageType === pageType);
}



// WEBPACK FOOTER //
// ./src/services/nav/menu-sections.ts